<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbReports',
  components: {},
}
</script>
